import React from "react";
import Cookies from 'universal-cookie';

export const cookies = new Cookies();

export const timeDifference = (nowEpoch, oldEpoch) => {
  var msPerMinute = 60 * 1000;
  var msPerHour = msPerMinute * 60;
  var msPerDay = msPerHour * 24;
  var msPerMonth = msPerDay * 30;

  var elapsed = nowEpoch - oldEpoch;

  if (elapsed < msPerMinute) {
    const val = Math.round(elapsed / 1000)
    return `${val} ${val == 1 ? 'second' : 'seconds'} ago`
  }

  else if (elapsed < msPerHour) {
    const val = Math.round(elapsed / msPerMinute)
    return  `${val} ${val == 1 ? 'minute' : 'minutes'} ago`
  }

  else if (elapsed < msPerDay) {
    const val = Math.round(elapsed / msPerHour)
    return  `${val} ${val == 1 ? 'hour' : 'hours'} ago`
  }

  else if (elapsed < msPerMonth) {
    const val = Math.round(elapsed / msPerDay)
    return  `${val} ${val == 1 ? 'day' : 'days'} ago`
  }

}

export const TimeDifference = ({oldEpoch}) => {
  if (!oldEpoch) return null
  const nowEpoch = Date.now()
  const msElapsed = nowEpoch - oldEpoch
  const timeDiffHumanReadable = timeDifference(nowEpoch, oldEpoch)
  const stale = msElapsed > 10800000 // 3 hours
  const staleShort = msElapsed > 1200000 // 20 min
  return (
    <div>
      <div>Data refreshed {timeDiffHumanReadable}. {staleShort ? 'Due to browser caching, you may need to refresh the page a few times to get the latest data.' : ''}</div>
      {stale ? <div className="bg-danger rounded p-3" style={{color:'white'}}>Data looks stale! Please try refreshing the page a few times, or opening the page in a Private/Incognito browser window.</div> : ''}
    </div>
  )
}

export const COOKIE_NAME = "infUser";
export const DONATE_COOKIE_NAME = "infDonate14"


export function getLastN(list, n) {
  if (n) {
    return list.slice(list.length - n)
  } else {
    return list.slice(list.length - 1)
  }
}

export function getLast(list) {
  return list[list.length - 1]
}

